import React, { useState, useEffect, useMemo, Component } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18n from '../../../i18n';
import moment from 'moment/moment';
import '../pagination/pagination.css';
import '../../Assets/Style/style.css';
import Pagination from '../pagination/pagination';
import { IoAddSharp } from 'react-icons/io5';
import Select from 'react-select';
import { RiRefreshLine } from 'react-icons/ri';
import { FaFileCircleExclamation } from 'react-icons/fa6';
import { FaRegEye, FaTrash, FaFileExport } from 'react-icons/fa';
import { HiPencil } from 'react-icons/hi2';
import LeaseApiService from '../../services/apiService';
import Modal from 'react-bootstrap/Modal';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { getRole } from '../../../Redux/selecters';
import CustomerMaster from './customerMaster';
import UpdateCustomerMaster from './editCustomer';
import ColumnFilterHeader from './columnFilterHeader';

const CustomerListing = () => {
  const { t } = useTranslation();
  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(20);
  const [pagination, setPagination] = useState();
  const [selectedRow, setSelectedRow] = useState(null);
  const apiService = new LeaseApiService();
  const [FilterTab, setFilterTab] = useState(true);
  const [previewModal, setPreviewModal] = useState(false);
  const [countriesList, setCountriesList] = useState([]);
  const [nationalityList, setNationalityList] = useState([]);
  const [sourceList, setSourceList] = useState([]);
  const [customerTypeList, setCustomerTypeList] = useState([]);
  const [salesPersonList, setSalesPersonList] = useState([]);
  const [leadStatus, setLeadStatus] = useState([]);
  const [formModal, setFormModal] = useState({ mode: null, data: null });
  const [columnFilters, setColumnFilters] = useState({});
  const role = useSelector(getRole);
  const isAdmin = role === 'Admin' || role === 'admin';
  let navigate = useNavigate();
  const [formData, setFormData] = useState({
    fullName: '',
    contactid: '',
    contactNo: '',
    source: '',
    type: '',
    salesPerson: '',
    email: '',
    id: '',
    salecustomer: '',
    leaseCustomer: '',
    prospectlevel: '',
    leadStatus: '',
    nationality: null,
    country: null,
    followupcheck: '',
    followupfrom: '',
    followtoCheck: '',
    followupto: '',
    createdfromcheck: '',
    createdfrom: '',
    createdtocheck: '',
    createdto: '',
  });
  useEffect(() => {
    fetchDropdownData();
  }, []);

  useEffect(() => {
    getItems();
  }, []);

  const fetchDropdownData = async () => {
    try {
      const params = new URLSearchParams();
      params.append('dropdownTypes', 'CustomerType,Country,Nationality');
      const res = await apiService.getApiParamater('CUSTOMER_MULTI', `?${params.toString()}`);
      setCustomerTypeList(res?.data?.dropdowns?.CustomerType);
      setCountriesList(res?.data?.dropdowns?.Country || []);
      setNationalityList(res?.data?.dropdowns?.Nationality || []);
      setLeadStatus([
        { value: 'All', text: 'All' },
        { value: 'Open', text: 'Open' },
        { value: 'In Process', text: 'In Process' },
        { value: 'Closed', text: 'Closed' },
      ]);
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  };
  const getItems = async (newPageNo = pagination?.currentPage) => {
    try {
      const params = new URLSearchParams();
      params.append('PageNo', newPageNo || 1);
      params.append('PageSize', pageSize || 20);
      params.append('FullName', formData?.fullName || '');
      params.append('LeadStatus', formData?.leadStatus?.label || '');
      params.append('ContactID', formData?.contactid || '');
      params.append('CustomerType', formData?.type?.label || '');
      params.append('Nationality', formData?.nationality?.label || '');
      // NOTE: api/Customer/Get has no Country query parameter at all (confirmed
      // against the live Swagger schema) - the backend silently ignores it, so
      // appending one here never actually narrowed the results. Filtered
      // client-side below instead, against the `country` field the API does
      // return on every row.
      params.append('Email', formData?.email || '');
      params.append('ContactNo', formData?.contactNo || '');
      params.append('Source', formData?.source?.label || '');
      params.append('SalesPerson', formData?.salesPerson?.label || '');
      params.append('IsSaleCustomer', formData?.salecustomer);
      params.append('IsLeaseCustomer', formData?.leaseCustomer);
      params.append('IsProspectLevel', formData?.prospectlevel);
      const res = await apiService.getApiParamater('GET_CUSTOMER', `?${params.toString()}`);
      let rows = res?.data?.result || [];
      const countryLabel = formData?.country?.label;
      if (countryLabel) {
        rows = rows.filter((row) => (row?.country || '').trim().toLowerCase() === countryLabel.trim().toLowerCase());
      }
      setRowData(rows);
      setPagination(res.data.paginationData);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching items:', error);
      // Handle error (e.g., show error message to user)
      setLoading(false); // Set loading to false even in case of error
    }
  };
  const dateFormatter = (params) => {
    const v = params.value;
    if (!v || v === '0') return '--';
    const date = moment(v);
    if (!date.isValid() || date.year() <= 1900) return '--';
    return date.format('DD-MMM-YYYY');
  };
  const emptyValueFormatter = (params) => {
    const v = params.value;
    if (v === null || v === undefined || v === '' || v === '0') return '--';
    return v;
  };
  const dateComparator = (date1, date2) => {
    const momentDate1 = moment(date1);
    const momentDate2 = moment(date2);
    return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
  };
  // The country code lives in Exp6 (confirmed by testing a live saved record -
  // customerMaster.js/editCustomer.js both write it there), the local number in
  // mainContactNo/contactNo. The documented Get schema for this list endpoint
  // doesn't list Exp6 as a returned field though, so this is read defensively
  // (multiple casings) and degrades to plain contactNo if the backend doesn't
  // actually include it on this endpoint.
  const resolveMobileNo = (row) => {
    const code = row?.exp6 || row?.Exp6 || row?.exp5 || row?.Exp5 || '';
    const local = row?.mainContactNo || row?.MainContactno || row?.mainContactno || row?.contactNo || '';
    if (!local || local === '0') return '';
    return code && code !== '0' ? `${code}${local}` : local;
  };
  const displayValue = (row, field, formatter, accessor) => {
    const raw = accessor ? accessor(row) : row?.[field];
    return formatter ? formatter({ value: raw }) : emptyValueFormatter({ value: raw });
  };
  const buildFilterParams = (field, formatter, accessor) => ({
    getValues: () => rowData.map((r) => displayValue(r, field, formatter, accessor)),
    selected: columnFilters[field],
    onChange: (vals) => setColumnFilters((prev) => ({ ...prev, [field]: vals })),
    onClear: () =>
      setColumnFilters((prev) => {
        const next = { ...prev };
        delete next[field];
        return next;
      }),
  });
  const filteredRowData = useMemo(() => {
    const activeFields = Object.keys(columnFilters).filter((f) => columnFilters[f] && columnFilters[f].length);
    if (!activeFields.length) return rowData;
    return rowData.filter((row) =>
      activeFields.every((field) => {
        const formatter = field === 'createdOn' ? dateFormatter : undefined;
        const accessor = field === 'contactNo' ? resolveMobileNo : undefined;
        return columnFilters[field].includes(displayValue(row, field, formatter, accessor));
      }),
    );
  }, [rowData, columnFilters]);
  const columnDefs = [
    {
      headerName: t('common.actions'),
      field: 'recordId',
      cellRenderer: BtnCellRenderer,
      pinned: 'left',
      cellRendererParams: {
        onView: (rowsData) => handleView(rowsData),
        onEdit: (rowsData) => handleEdit(rowsData),
        onDelete: (rowsData) => handleDelete(rowsData),
        canDelete: isAdmin,
      },
      suppressMovable: true,
      sortable: false,
      filter: false,
      width: 110,
    },
    {
      headerName: t('customerMaster.columns.contactId'),
      field: 'customerNo',
      suppressMovable: true,
      sortable: true,
      width: 130,
      pinned: 'left',
      valueFormatter: emptyValueFormatter,
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('customerNo'),
    },
    {
      headerName: t('customerMaster.columns.name'),
      field: 'customerName',
      suppressMovable: true,
      sortable: true,
      width: 250,
      pinned: 'left',
      valueFormatter: emptyValueFormatter,
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('customerName'),
    },
    {
      headerName: t('customerMaster.columns.mobileNo'),
      suppressMovable: true,
      sortable: true,
      width: 150,
      valueGetter: (p) => resolveMobileNo(p.data) || '--',
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('contactNo', undefined, resolveMobileNo),
    },
    {
      headerName: t('customerMaster.columns.email'),
      field: 'emailId',
      suppressMovable: true,
      sortable: true,
      width: 250,
      valueFormatter: emptyValueFormatter,
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('emailId'),
    },
    {
      headerName: t('customerMaster.columns.id'),
      field: 'tradeLicNo',
      suppressMovable: true,
      sortable: true,
      width: 130,
      valueFormatter: emptyValueFormatter,
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('tradeLicNo'),
    },
    {
      headerName: t('customerMaster.columns.country'),
      field: 'country',
      suppressMovable: true,
      sortable: true,
      width: 150,
      valueFormatter: emptyValueFormatter,
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('country'),
    },
    {
      headerName: t('customerMaster.columns.nationality'),
      field: 'nationality',
      suppressMovable: true,
      sortable: true,
      width: 150,
      valueFormatter: emptyValueFormatter,
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('nationality'),
    },
    {
      headerName: t('customerMaster.columns.city'),
      field: 'city',
      suppressMovable: true,
      sortable: true,
      width: 150,
      valueFormatter: emptyValueFormatter,
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('city'),
    },
    {
      headerName: t('customerMaster.columns.createdOn'),
      field: 'createdOn',
      valueFormatter: dateFormatter,
      comparator: dateComparator,
      suppressMovable: true,
      sortable: true,
      width: 136,
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('createdOn', dateFormatter),
    },
    {
      headerName: t('customerMaster.columns.createdBy'),
      field: 'createdBy',
      suppressMovable: true,
      sortable: true,
      width: 250,
      valueFormatter: emptyValueFormatter,
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('createdBy'),
    },
    {
      headerName: t('customerMaster.columns.project'),
      field: 'unitNo',
      suppressMovable: true,
      sortable: true,
      width: 100,
      valueFormatter: emptyValueFormatter,
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('unitNo'),
    },
  ];
  const handlenew = () => {
    setFormModal({ mode: 'create', data: null });
  };
  const handleEdit = (rowsData) => {
    if (rowsData) {
      setFormModal({ mode: 'edit', data: rowsData });
    }
  };
  const handleView = (rowsData) => {
    if (rowsData) {
      setFormModal({ mode: 'view', data: rowsData });
    }
  };
  const handleDelete = (rowsData) => {
    if (rowsData) {
      setSelectedRow(rowsData);
      setPreviewModal(true);
    }
  };
  const handleConfirmDelete = async () => {
    if (!selectedRow) return;
    try {
      const body = { recordId: 0, customerNo: selectedRow?.customerNo || '' };
      const res = await apiService.delete('DELETE_CUSTOMER', body);
      if (res?.data?.isSuccessful && res?.data?.result) {
        toast.success(res?.data?.message || t('customerMaster.deleteSuccess'));
        setPreviewModal(false);
        setSelectedRow(null);
        getItems();
      } else {
        toast.warning(res?.data?.message || t('customerMaster.deleteFailed'));
      }
    } catch (error) {
      console.error('Error deleting customer:', error);
      toast.error(t('customerMaster.deleteFailed'));
    }
  };
  const closeFormModal = () => {
    setFormModal({ mode: null, data: null });
  };
  const handleFormSaved = () => {
    closeFormModal();
    getItems(1);
  };
  const handleClearFilters = () => {
    setFormData({
      fullName: '',
      contactid: '',
      contactNo: '',
      source: '',
      type: '',
      salesPerson: '',
      email: '',
      id: '',
      salecustomer: '',
      leaseCustomer: '',
      prospectlevel: '',
      leadStatus: '',
      nationality: null,
      country: null,
      followupcheck: '',
      followupfrom: '',
      followtoCheck: '',
      followupto: '',
      createdfromcheck: '',
      createdfrom: '',
      createdtocheck: '',
      createdto: '',
    });
    setColumnFilters({});
    getItems(1);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleDropDownChange = ({ name, value }) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const exportPDF = () => {
    if (!filteredRowData?.length) {
      alert('No data available to export');
      return;
    }
    const doc = new jsPDF('landscape');
    const primaryColor = [110, 81, 153]; // #6E5199

    doc.setFillColor(...primaryColor);
    doc.rect(0, 0, 297, 25, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(20);
    doc.text('CUSTOMER LIST REPORT', 148.5, 15, { align: 'center' });
    doc.setFontSize(9);
    doc.text(`Generated On: ${new Date().toLocaleDateString()}`, 280, 21, { align: 'right' });
    doc.setTextColor(0, 0, 0);

    const tableColumn = ['Contact ID', 'Name', 'Mobile No', 'Email', 'ID', 'Country', 'Nationality', 'City', 'Created On', 'Created By', 'Project'];
    const tableRows = filteredRowData.map((item) => [
      item.customerNo || '-',
      item.customerName || '-',
      resolveMobileNo(item) || '-',
      item.emailId || '-',
      item.tradeLicNo || '-',
      item.country || '-',
      item.nationality || '-',
      item.city || '-',
      dateFormatter({ value: item.createdOn }),
      item.createdBy || '-',
      item.unitNo || '-',
    ]);

    doc.autoTable({
      startY: 35,
      head: [tableColumn],
      body: tableRows,
      theme: 'grid',
      styles: { fontSize: 8, cellPadding: 3, valign: 'middle', lineColor: [220, 220, 220], lineWidth: 0.1 },
      headStyles: { fillColor: primaryColor, textColor: [255, 255, 255], fontStyle: 'bold', halign: 'center', fontSize: 9 },
      alternateRowStyles: { fillColor: [248, 246, 252] },
      bodyStyles: { textColor: [50, 50, 50] },
      margin: { left: 10, right: 10 },
      didDrawPage: function (data) {
        const pageCount = doc.internal.getNumberOfPages();
        doc.setFontSize(8);
        doc.setTextColor(120);
        doc.text(`Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`, data.settings.margin.left, doc.internal.pageSize.height - 5);
        doc.text('Customer List', doc.internal.pageSize.width - 40, doc.internal.pageSize.height - 5);
      },
    });
    doc.save('Customer_List.pdf');
  };
  return (
    <div className="p-3 customer-list-page">
      <div className="cost-center-section">
        <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setFilterTab(!FilterTab)}>
          <div className="h6 pt-1">{t('common.searchParameters')}</div>
        </div>
        <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
          <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
            <div className="d-flex gap-3 align-items-stretch">
            <div className="form-group grid-contain flex-grow-1">
              <div className="d-flex">
                <label className="form-label pt-2 start">{t('customerMaster.filters.contactId')}</label>
                <input type="text" className="p-2 form-control w-75" name="contactid" value={formData.contactid} onChange={handleInputChange} />
              </div>
              <div className="d-flex">
                <label className="form-label pt-2 start">{t('customerMaster.filters.contactNo')}</label>
                <input type="text" className="p-2 form-control w-75" name="contactNo" value={formData.contactNo} onChange={handleInputChange} />
              </div>
              <div className="d-flex">
                <label htmlFor="validationCustom18" className="form-label">
                  {t('customerMaster.filters.type')}
                </label>
                <Select
                  className="p-0 w-100"
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  value={formData?.type}
                  onChange={(selectedOption) => handleDropDownChange({ name: 'type', value: selectedOption })}
                  options={customerTypeList?.map((country) => ({ value: country, label: country?.text }))}
                />
              </div>
              <div className="d-flex">
                <label htmlFor="validationCustom18" className="form-label">
                  {t('customerMaster.filters.country')}
                </label>
                <Select
                  className="p-0 w-100"
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  value={formData?.country}
                  onChange={(selectedOption) => handleDropDownChange({ name: 'country', value: selectedOption })}
                  options={countriesList?.map((item) => ({ value: item, label: item?.text }))}
                  isClearable
                />
              </div>
              <div className="d-flex">
                <label htmlFor="validationCustom18" className="form-label">
                  {t('customerMaster.filters.nationality')}
                </label>
                <Select
                  className="p-0 w-100"
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  value={formData?.nationality}
                  onChange={(selectedOption) => handleDropDownChange({ name: 'nationality', value: selectedOption })}
                  options={nationalityList?.map((item) => ({ value: item, label: item?.text }))}
                  isClearable
                />
              </div>
              <div className="d-flex">
                <label className="form-label pt-2 start">{t('customerMaster.filters.name')}</label>
                <input type="text" className="p-2 form-control w-75" name="fullName" value={formData.fullName} onChange={handleInputChange} />
              </div>
              <div className="d-flex">
                <label className="form-label pt-2 start">{t('customerMaster.filters.email')}</label>
                <input type="email" className="p-2 form-control w-75" name="email" value={formData.email} onChange={handleInputChange} />
              </div>
              <div className="d-flex">
                <label className="form-label pt-2 start">{t('customerMaster.filters.id')}</label>
                <input type="text" className="p-2 form-control w-75" name="id" value={formData.id} onChange={handleInputChange} />
              </div>
              <div className="d-flex">
                <label htmlFor="validationCustom18" className="form-label">
                  {t('customerMaster.filters.leadStatus')}
                </label>
                <Select
                  className="p-0 w-100"
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  value={formData?.leadStatus}
                  onChange={(selectedOption) => handleDropDownChange({ name: 'leadStatus', value: selectedOption })}
                  options={leadStatus?.map((country) => ({ value: country, label: country?.text }))}
                />
              </div>
              <div className="d-flex justify-content-around">
                <div className="d-flex gap-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="salecustomer"
                    style={{ width: '20px', height: '20px' }}
                    checked={formData.salecustomer}
                    onChange={(e) => setFormData((prev) => ({ ...prev, salecustomer: e.target.checked }))}
                  />
                  <label className="form-check-label" htmlFor="salecustomer">
                    {t('customerMaster.filters.saleCustomer')}
                  </label>
                </div>
                <div className="d-flex gap-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="leaseCustomer"
                    style={{ width: '20px', height: '20px' }}
                    checked={formData.leaseCustomer}
                    onChange={(e) => setFormData((prev) => ({ ...prev, leaseCustomer: e.target.checked }))}
                  />
                  <label className="form-check-label" htmlFor="leaseCustomer">
                    {t('customerMaster.filters.leaseCustomer')}
                  </label>
                </div>
              </div>
              <div className="d-flex gap-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="prospectlevel"
                  style={{ width: '20px', height: '20px' }}
                  checked={formData.prospectlevel}
                  onChange={(e) => setFormData((prev) => ({ ...prev, prospectlevel: e.target.checked }))}
                />
                <label className="form-check-label" htmlFor="taxInclusive">
                  {t('customerMaster.filters.prospectLevel')}
                </label>
              </div>
              {/* <div className="d-flex justify-content-around">
                                <div className="d-flex gap-3">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="createdfromcheck"
                                        style={{ width: '20px', height: '20px' }}
                                        checked={formData.createdfromcheck}
                                        onChange={(e) => setFormData(prev => ({ ...prev, createdfromcheck: e.target.checked }))}
                                    />
                                    <label className="form-check-label" htmlFor="createdfromcheck">
                                        Created From
                                    </label>
                                </div>
                                <div className="d-flex">
                                    <DatePicker
                                        selected={formData.createdfrom}
                                        onChange={(date) => handleDateChange({ name: 'createdfrom', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100 datepicker-icon"
                                    />
                                </div>
                            </div>
                            <div className="d-flex justify-content-around">
                                <div className="d-flex gap-3">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="createdtocheck"
                                        style={{ width: '20px', height: '20px' }}
                                        checked={formData.createdtocheck}
                                        onChange={(e) => setFormData(prev => ({ ...prev, createdtocheck: e.target.checked }))}
                                    />
                                    <label className="form-check-label" htmlFor="createdtocheck">
                                        Created To
                                    </label>
                                </div>
                                <div className="d-flex">
                                    <DatePicker
                                        selected={formData.createdto}
                                        onChange={(date) => handleDateChange({ name: 'createdto', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100 datepicker-icon"
                                    />
                                </div>
                            </div> */}
            </div>
            <div className="customer-search-actions">
              <div onClick={() => getItems()} className="mainbtn flex-end gap-2">
                <FaFileCircleExclamation color="#fff" className="center mt-2 mx-2" />
                <div className="center">{t('common.search')}</div>
              </div>
              <div onClick={() => handleClearFilters()} className="mainbtnRed flex-end gap-2">
                <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                <div className="center">{t('common.reset')}</div>
              </div>
              <div onClick={() => exportPDF()} className="mainbtnGry flex-end gap-2">
                <FaFileExport color="#fff" className="center mt-2 mx-2" />
                <div className="center">{t('common.export')}</div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-box2 p-3">
        {loading ? (
          <div>{t('common.loading')}</div>
        ) : (
          <>
            <div className="d-flex justify-contant-between ">
              <h5 className="col mainInvHead">{t('customerMaster.pageTitle')}</h5>
              <div className="d-flex justify-content-end gap-1">
                <div className="col center">
                  <button className="mainbtn " type="submit" onClick={() => handlenew()}>
                    <IoAddSharp color="#fff" className="center mt-1" /> <div>{t('common.add')}</div>
                  </button>
                </div>
              </div>
            </div>
            <div className="gridshad  mt-3">
              <div className="ag-theme-quartz customer-grid" style={{ height: 650 }}>
                <AgGridReact
                  getRowStyle={(params) => {
                    if (params.node.rowIndex % 2 === 0) {
                      return { background: '#F0EDF5' };
                    } else {
                      return { background: '#fff' };
                    }
                  }}
                  rowData={filteredRowData}
                  enableFilter={true}
                  floatingFilter={true}
                  columnDefs={columnDefs}
                  frameworkComponents={{ BtnCellRenderer }}
                />
              </div>
              <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
            </div>
          </>
        )}
      </div>

      <Modal show={previewModal} size="md" onHide={() => setPreviewModal(false)} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>{t('customerMaster.deleteTitle')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Modal.Title>{t('customerMaster.deleteConfirm', { name: selectedRow?.customerName })}</Modal.Title>
        </Modal.Body>
        <Modal.Footer className="end p-3">
          <button
            className="mainbtnRed"
            onClick={() => {
              setPreviewModal(false);
              setSelectedRow(null);
            }}
          >
            {t('common.cancel')}
          </button>
          <button className="mainbtn" onClick={handleConfirmDelete}>
            {t('common.delete')}
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={!!formModal.mode}
        onHide={closeFormModal}
        backdrop="static"
        keyboard={false}
        centered
        dialogClassName="customer-form-modal"
        contentClassName="p-0"
      >
        <Modal.Body style={{ padding: 0 }}>
          {formModal.mode === 'create' && <CustomerMaster onClose={closeFormModal} onSaved={handleFormSaved} />}
          {(formModal.mode === 'edit' || formModal.mode === 'view') && (
            <UpdateCustomerMaster
              initialData={formModal.data}
              viewOnly={formModal.mode === 'view'}
              onClose={closeFormModal}
              onSaved={handleFormSaved}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};
class BtnCellRenderer extends Component {
  render() {
    const { data, onView, onEdit, onDelete, canDelete } = this.props;
    const stop = (fn) => (e) => {
      e.stopPropagation();
      fn?.(data);
    };
    return (
      <div className="customer-row-actions">
        <FaRegEye color="#6E5199" size={16} title={i18n.t('common.view')} onClick={stop(onView)} />
        <HiPencil color="#313a46" size={16} title={i18n.t('common.edit')} onClick={stop(onEdit)} />
        <FaTrash
          color={canDelete ? '#DC3545' : '#c9c9c9'}
          size={14}
          title={canDelete ? i18n.t('common.delete') : i18n.t('common.onlyAdminCanDelete')}
          style={{ cursor: canDelete ? 'pointer' : 'not-allowed' }}
          onClick={canDelete ? stop(onDelete) : undefined}
        />
      </div>
    );
  }
}
export default CustomerListing;
